import { HStack, Badge, Text } from '@chakra-ui/react'
import { statusConfig } from '../utils/statusConfig'

export function StatusLegend() {
  return (
    <HStack spacing={4} mr={4} display={{ base: 'none', md: 'flex' }}>
      <HStack>
        <Badge colorScheme="yellow" p={1} borderRadius="md" />
        <Text fontSize="10px" color="#313E44">
          Aguardando Aprovação
        </Text>
      </HStack>
      <HStack>
        <Badge colorScheme="green" p={1} borderRadius="md" />
        <Text fontSize="10px" color="#313E44">
          Aprovado
        </Text>
      </HStack>
      <HStack>
        <Badge colorScheme="red" p={1} borderRadius="md" />
        <Text fontSize="10px" color="#313E44">
          Reprovado
        </Text>
      </HStack>
    </HStack>
  )
}
